import React from 'react';
import { View } from 'react-native';
import KeyRoundSvg from '@assets/images/svg/key-round.svg';

export interface KeyRoundIconProps {
    size?: number;
    color?: string;
}

export function KeyRoundIcon({ size = 40, color = '#333333' }: KeyRoundIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <KeyRoundSvg width={size} height={size} color={color} />
        </View>
    );
}

export default KeyRoundIcon;
